import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { map } from 'lodash'
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'

import ProductItem from 'components/DisplayCategories/ProductItem'
import { setItemsIndexes } from 'store/Items/actions'

const ProductList = ({ assignedItems }) => {
  const [items, setItems] = useState(assignedItems)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setItemsIndexes(items))
  }, [items, dispatch])

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 250,
        tolerance: 5,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  )

  const handleDragEnd = (event) => {
    const { active, over } = event
    if (active.id !== over?.id) {
      setItems((items) => {
        const oldIndex = items.findIndex(
          (item) => item.uuid === active.id
        )
        const newIndex = items.findIndex(
          (item) => item.uuid === over?.id
        )

        return arrayMove(items, oldIndex, newIndex)
      })
    }
  }

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={items.map((item) => item.uuid)}
        strategy={verticalListSortingStrategy}
      >
        {map(items, (item) => (
          <ProductItem
            key={item.uuid}
            uuid={item.uuid}
            name={item.name}
          />
        ))}
      </SortableContext>
    </DndContext>
  )
}

ProductList.propTypes = {
  assignedItems: PropTypes.array.isRequired,
}

export default ProductList
